import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';
import { AuthRoutingModule } from './auth-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from '../../../common/interceptors/auth';
import { RegisterGuard } from '../../../common/guards/register.guard';
import { LoginRegisterPageComponent } from './pages/login-register-page/login-register-page.component';
import { PickNamePageComponent } from './pages/pick-name-page/pick-name-page.component';
import { VerificationPageComponent } from './pages/verification-page/verification-page.component';
import { LoginRegisterComponent } from '../../../common/components/auth/login-register/login-register.component';
import { PickNameComponent } from '../../../common/components/auth/pick-name/pick-name.component';
import { VerificationComponent } from '../../../common/components/auth/verification/verification.component';

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    HttpClientModule,
    LoginRegisterComponent,
    PickNameComponent,
    VerificationComponent,
  ],
  declarations: [
    AuthComponent,
    LoginRegisterPageComponent,
    PickNamePageComponent,
    VerificationPageComponent,
  ],
  providers: [
    RegisterGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class AuthModule {}
